import { LitElement, html, TemplateResult, nothing } from 'lit';
import { property, customElement } from 'lit/decorators.js';

import { DetectionsSectionLabels, EdrIncidentDetailsPanelEvents } from '../../../edrIncidentDetails/types';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { getSeverityScoreClass } from '../../../../utils/xdr.utils';
import { GridEvents } from '../../../../grid/types/common';

/**
 * @summary Type here the description of this component
 * @tag incident-details-detections-section
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('incident-details-detections-section')
export class IncidentDetailsDetectionsSectionWebComponent extends LitElement {
  @property({ attribute: false })
  triggerName = '';

  @property({ attribute: false })
  incident: any = null;

  @property({ attribute: false })
  alerts: Array<any> = [];

  @property({ attribute: false })
  translations: DetectionsSectionLabels;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="title-container d-flex flex-row mb-2">
        <gz-title
          fontSize="${FontSizes.PARAGRAPH_11}"
          fontWeight="${FontWeights.SEMIBOLD}"
          class="section-title w-auto text-uppercase"
          >${this.translations.sectionTitle}</gz-title
        >
        <gz-text
          fontSize="${FontSizes.PARAGRAPH_10}"
          fontWeight="${FontWeights.LIGHT}"
          class="counter w-auto text-uppercase"
          >${this.getNumberOfAlerts()}</gz-text
        >
      </div>
      <gz-labeled-content label="${this.translations.incidentTrigger}">
        <gz-tooltip isEllipsis tooltiptext="${this.triggerName}"
          ><gz-text class="trigger-name" fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.MEDIUM}"
            >${this.triggerName}</gz-text
          ></gz-tooltip
        >
      </gz-labeled-content>
      ${this.renderAlerts()}
    `;
  }

  renderAlerts() {
    if (this.alerts.length === 0) {
      return nothing;
    }

    const templateItems: Array<TemplateResult> = [];
    this.alerts.forEach(alert => {
      templateItems.push(
        html` <div
          class="container-alerts d-flex flex-row align-items-center"
          @click="${() => this.handleAlertClick(alert)}"
        >
          <gz-icon-label icon="icon-sva" iconColor="${getSeverityScoreClass(alert.eventSeverity)}"></gz-icon-label>
          <gz-tooltip class="event-tooltip" isEllipsis tooltiptext="${alert.eventName}"
            ><gz-text class="event-name" fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.NORMAL}"
              >${alert.eventName}</gz-text
            ></gz-tooltip
          >
        </div>`
      );
    });

    return html` <show-more-items-in-bulk
      .items=${templateItems}
      .showMoreButtonText="${this.translations.showMoreBtn}"
    >
    </show-more-items-in-bulk>`;
  }

  handleAlertClick(alert) {
    Application.modules.edr.controller.helpers.sidePanelsManager.openEdrAlertDetailsPanel(
      Ext.ComponentQuery.query('securityIncidents-modulePanel')[0],
      'incident-map__infoPanel edr-grid-side-panel-alert-details side-panel-fix-width opened-from-another-panel ext-alert-side-menu-opened-from-webcomponets',
      alert,
      true,
      0,
      () => {
        this.dispatchEvent(
          new CustomEvent(EdrIncidentDetailsPanelEvents.ALERT_CLOSED, {
            detail: {},
            bubbles: true,
            composed: true,
          })
        );
      },
      {
        data: this.incident
      },
    );

    this.dispatchEvent(
      new CustomEvent(EdrIncidentDetailsPanelEvents.ALERT_OPENED, {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }

  getNumberOfAlerts() {
    if (this.alerts.length > 0) {
      return html`(${this.alerts.length})`;
    }

    return nothing;
  }

  constructor() {
    super();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'incident-details-detections-section': IncidentDetailsDetectionsSectionWebComponent;
  }
}
